<template>
  <div class="main">
    <mt-header :title="$t('发现')" class="dl_header_white dl_line_bottom" fixed></mt-header>
    <div class="dl_line"></div>

    <div class="container">
      <div class="swiper">
        <mt-swipe>
          <mt-swipe-item v-for="(item, index) in banner" :key="index">
            <div class="banner-title" ><span>{{item.name}}</span><img :src="item.coin_icon" class="media-logo-small" style="width:15px;height:15px"></div>
            <div class="banner-desc" ><span>{{item.intro}}</span></div>
            <a @click="myAlert(item,$event)">
              <img :src="item.banner_image">
            </a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="dl_line_bottom">
        <h4 class="cateTitle dl_font1_color">{{$t('最近流行')}}</h4>
        <div class="dappItem" v-for="(item, index) in recommend" :key="index">
          <a  @click="myAlert(item,$event)">
            <div class="media">
              <div class="media-bottom">
                <img :src="item.icon" class="media-logo">
              </div>
              <div class="media-body">
                <div class="media-heading wx_one_ellipsis dl_font1_color">
                  <span>{{item.name}}</span>
                  <img :src="item.coin_icon" class="media-logo-small">
                </div>
                <span class="wx_one_ellipsis dl_font12 media-desc dl-desc-color">{{item.intro}}</span>
              </div>
              <img class="back" src="@/assets/img/coinDetail/ico_gengduo.png">
            </div>
          </a>
        </div>
      </div>

      <div v-for="(item, index) in list" :key="index" class="dl_line_bottom">
        <router-link class="all dl_main_color" :to="'/faxiantype?type='+item.category_id">{{$t('全部')}}</router-link>
        <h4 class="cateTitle dl_font1_color">{{item.cate_name}}</h4>

        <div class="dappItem" v-for="(temp, i) in item.list" :key="i">
          <a @click="myAlert(temp,$event)">
            <div class="media">
              <div class="media-bottom">
                <img :src="temp.icon" class="media-logo">
              </div>
              <div class="media-body">
                <div class="media-heading wx_one_ellipsis dl_font1_color">
                  <span>{{temp.name}}</span>
                  <img :src="temp.coin_icon" class="media-logo-small">
                </div>
                <span class="wx_one_ellipsis dl_font12 media-desc dl-desc-color">{{temp.intro}}</span>
              </div>
              <img class="back" src="@/assets/img/coinDetail/ico_gengduo.png">
            </div>
          </a>
        </div>
      </div>
      <img class="dappwallet"  @click="goMyDapp()" src="@/assets/img/dappwallet.png">
    </div>
  </div>
</template>

<script>
import Sort from "@/components/Sort";
import { Toast ,MessageBox} from "mint-ui";
import { httpGetFaxian } from "@/api/faxian";
import banner1 from "@/assets/img/banner_yaoqinghaoyou.png";
export default {
  name: "Index",
  components: { Toast, Sort,MessageBox },
  data() {
    return {
      banner: [],
      recommend: [],
      list: []
    };
  },
  methods: {
    getData: function() {
      httpGetFaxian({})
        .then(res => {
          this.banner = res.data.is_hot;
          this.recommend = res.data.is_recommend;
          this.list = res.data.list;
        })
        .catch(() => {});
    },
    goMyDapp(){
      this.$router.push('/dappwallet')
    },
    myAlert:function(item,event){
      MessageBox({
        title:this.$t('HMC Wallet Pro 声明'),
        message: this.$t('您即将进入第三方Dapp')+'：<br>'+'<span class="dl_main_color">"'+item.name+'"</span>'+'<br>'+this.$t('请务必留意该Dapp的相关用户协议和隐私政策，保护您的资产安全。您在这一Dapp中的所有行为和使用情况，均由该Dapp的供应商负责。'),
        showCancelButton:true
      }).then((action)=>{
        if(action == 'confirm'){
          window.location.href=item.addr
        }
      })
    }
  },
  created: function() {
    this.getData();
  }
};
</script>

<style scoped>
.main {
  padding-top: 40px;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  height: 270px;
}
.swiper img {
  width: 100%;
  height: 180px;
  border-radius:5px;
}


.cateTitle {
  margin: 15px 10px 10px 10px;
}
.dappItem {
  color: #233240;
  opacity: 0.9;
  text-decoration: none;
  background-color: transparent;
  height: 70px;
  position: relative;
}

.media {
  overflow: hidden;
}

.media-logo {
  border-radius: 5px;
  width: 50px;
  vertical-align: middle;
  border-style: none;
  height: auto;
  margin: 5px;
}
.media-logo-small {
  width: 15px;
  margin-left: 5px;
  margin-top: 2px;
}
.media-body {
  margin-left: 70px;
  padding-top:10px;
}
.media-bottom {
  float: left;
}
.media-heading {
  line-height: 25px;
}
.media-desc {
  line-height: 15px;
}
.back {
  height: 10px;
  position: absolute;
  right: 5px;
  top: 20px;
}
.all {
  float: right;
  font-size: 14px;
}
.dl-desc-color{
  color:#888;
 }
.banner-title{
  font-weight:bold;
  margin:5px 0px 0px 0px;
  font-size: 16px;
  line-height:23px;
}
.banner-desc{
  font-size: 14px;
  color:#888;
  line-height:20px;
  margin-bottom:10px;
}
.dappwallet{
  position: fixed;
  bottom: 15%;
  right: 20px;
  width: 60px;
}
</style>

